export const adaptComponentResponse = (response) => {
  return (
    response?.components?.map((each) => ({
      label: each.name,
      value: each.name,
    })) || []
  );
};
